// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"697":"1dd7a849","3331":"95f1c932","8270":"27059a56"}[chunkId] + ".chunk.css";
};